import React from 'react';
import PropTypes from 'prop-types';

import UpdateUserForm from './UpdateUserForm';

const SeniorInformationSecurityOfficerForm = ({ system, user }) => {
  const tooltip = "The person responsible for the assurance that security controls are implemented and working as designed.";

  return (
    <div id="senior-information-security-officer-container">
      <UpdateUserForm
        system={system}
        user={user}
        title="Senior Information Security Officer"
        tooltip={tooltip}
        roleName="SeniorInformationSecurityOfficer"
      />
    </div>
  );
};

SeniorInformationSecurityOfficerForm.propTypes = {
  system: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string,
    description: PropTypes.string
  }).isRequired,
  user: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string
  })
};

export default SeniorInformationSecurityOfficerForm;
